import { createQueryString } from 'services/production/utils/createQueryString';

type SignOutParams = {
  redirect?: string;
};

const createProfilePathName = (subPath: string) => `/profile${subPath}`;

export const routes = {
  // DASHBOARD

  dashboard() {
    return createProfilePathName('/dashboard');
  },
  dashboardPattern() {
    return createProfilePathName('/dashboard');
  },

  // OAUTH2

  oauth2() {
    return createProfilePathName('/oauth2');
  },
  oauth2Pattern() {
    return createProfilePathName('/oauth2');
  },

  // SIGNOUT

  signOut(params?: SignOutParams) {
    if (params) {
      return createProfilePathName(`/signout?${createQueryString(params)}`);
    }

    return createProfilePathName('/signout');
  },
  signOutPattern() {
    return createProfilePathName('/signout');
  },

  // REGISTRATION

  registration() {
    return createProfilePathName('/registration');
  },
  registrationPattern() {
    return createProfilePathName('/registration');
  },
  registrationDemo() {
    return createProfilePathName('/registration/demo');
  },
  registrationDemoPattern() {
    return createProfilePathName('/registration/demo');
  },
  registrationProd(orderId?: string) {
    if (orderId) {
      return createProfilePathName(`/registration/prod/${orderId}`);
    }

    return createProfilePathName('/registration/prod');
  },
  registrationProdPattern() {
    return createProfilePathName('/registration/prod/:orderId?');
  },
  registrationPartner() {
    return createProfilePathName('/registration/partner');
  },
  registrationPartnerPattern() {
    return createProfilePathName('/registration/partner');
  },

  // RESTORE

  restorePassword() {
    return createProfilePathName('/restore');
  },
  restorePasswordPattern() {
    return createProfilePathName('/restore');
  },
  restorePasswordExpiredPattern() {
    return createProfilePathName('/restore/expired');
  },
  restorePasswordValidToken(token: string) {
    return createProfilePathName(`/restore/valid/${token}`);
  },
  restorePasswordValidTokenPattern() {
    return createProfilePathName('/restore/valid/:token');
  },

  // UTILITY

  authorizationWithDemo() {
    return createProfilePathName('/authorizationWithDemo');
  },
  authorizationWithDemoPattern() {
    return createProfilePathName('/authorizationWithDemo');
  },

  authorizationWithProd() {
    return createProfilePathName('/authorizationWithProd');
  },
  authorizationWithProdPattern() {
    return createProfilePathName('/authorizationWithProd');
  },

  order(orderId: string) {
    return createProfilePathName(`/order/${orderId}`);
  },
  orderPattern() {
    return createProfilePathName('/order/:orderId');
  },

  // CLIENTS

  clientsRoot() {
    return createProfilePathName('/clients');
  },
  clientsRootPattern() {
    return createProfilePathName('/clients');
  },
  clients(page: number = 1) {
    return createProfilePathName(`/clients/${page}`);
  },
  clientsPattern() {
    return createProfilePathName('/clients/:page');
  },
  clientsActivePattern() {
    return createProfilePathName('/clients/active');
  },
  clientsActive() {
    return createProfilePathName('/clients/active');
  },
  clientsCancelledPattern() {
    return createProfilePathName('/clients/cancelled');
  },
  clientsCancelled() {
    return createProfilePathName('/clients/cancelled');
  },

  // ARCHIVE

  archiveRoot() {
    return createProfilePathName('/archive');
  },
  archiveRootPattern() {
    return createProfilePathName('/archive');
  },
  archive(page: number = 1) {
    return createProfilePathName(`/archive/${page}`);
  },
  archivePattern() {
    return createProfilePathName('/archive/:page');
  },

  // PRODUCTS

  products() {
    return createProfilePathName('/products');
  },
  productsPattern() {
    return createProfilePathName('/products');
  },

  // BILLS

  billsRoot() {
    return createProfilePathName('/bills');
  },
  billsRootPattern() {
    return createProfilePathName('/bills');
  },
  bills(page: number = 1) {
    return createProfilePathName(`/bills/${page}`);
  },
  billsPattern() {
    return createProfilePathName('/bills/:page');
  },

  // PAYMENTS

  cardPaymentsRoot() {
    return createProfilePathName('/card-payments');
  },
  cardPaymentsRootPattern() {
    return createProfilePathName('/card-payments');
  },
  cardPayments(page: number = 1) {
    return createProfilePathName(`/card-payments/${page}`);
  },
  cardPaymentsPattern() {
    return createProfilePathName('/card-payments/:page');
  },

  // GIRO PAYMENTS

  giroPaymentsRoot() {
    return createProfilePathName('/giro-payments');
  },
  giroPaymentsRootPattern() {
    return createProfilePathName('/giro-payments');
  },
  giroPayments(page: number = 1) {
    return createProfilePathName(`/giro-payments/${page}`);
  },
  giroPaymentsPattern() {
    return createProfilePathName('/giro-payments/:page');
  },

  // PARTNERS

  partnersRoot() {
    return createProfilePathName('/partners');
  },
  partnersRootPattern() {
    return createProfilePathName('/partners');
  },
  partners(page: number = 1) {
    return createProfilePathName(`/partners/${page}`);
  },
  partnersPattern() {
    return createProfilePathName('/partners/:page');
  },

  // BILLS

  promocodesRoot() {
    return createProfilePathName('/promocodes');
  },
  promocodesRootPattern() {
    return createProfilePathName('/promocodes');
  },
  promocodes(page: number = 1) {
    return createProfilePathName(`/promocodes/${page}`);
  },
  promocodesPattern() {
    return createProfilePathName('/promocodes/:page');
  },

  // PROMOCODE

  promocode() {
    return createProfilePathName('/promocode');
  },
  promocodePattern() {
    return createProfilePathName('/promocode');
  },
};
